import PropTypes from 'prop-types'

import ArticleGridBlock from './ArticleGridBlock'
import HighlightBlock from './HighlightBlock'
import ShowcaseBlock from './ShowcaseBlock'
import React from 'react'

function BlocksNews({ children = [], ...rest }) {
  if (children?.length < 1) return null

  const articleGridBlock = 'AcfNewsBlocksArticleGridLayout'
  const highlightBlock = 'AcfNewsBlocksHighlightLayout'
  const showcaseBlock = 'AcfNewsBlocksShowcaseLayout'

  const blockType = (block) => {
    switch (block.__typename) {
      case articleGridBlock:
        return {
          block: 'articleGrid',
          component: ArticleGridBlock,
        }
      case highlightBlock:
        return {
          block: 'highlight',
          component: HighlightBlock,
        }
      case showcaseBlock:
        return {
          block: 'showcase',
          component: ShowcaseBlock,
        }
      default:
        return null
    }
  }

  return children.map((child, i) => {
    // console.log('child: ', child)
    if (!child) return null
    const getBlockType = blockType(child)
    if (!getBlockType) return null
    const articleGrid = getBlockType.block === 'articleGrid'
    const component = React.createElement(getBlockType.component, {
      ...child,
      key: i,
      ...rest,
    })
    return (
      <div
        key={i}
        className={`${getBlockType.block}Block
        `}
      >
        {component}
      </div>
    )
  })
}

BlocksNews.propTypes = {
  children: PropTypes.array,
  rest: PropTypes.object,
}

export default BlocksNews
